import type { ReactNode } from 'react';

import { cn } from '@poseidon/components/cn';
import { Alerts } from '@poseidon/components/StrokeIcons';

/** The card shown when signing in or loading the account hits a problem: a warning title, then what to do. */
export const AuthProblemCard = ({
  title,
  className,
  children,
}: {
  title: string;
  className?: string;
  children: ReactNode;
}) => (
  <div
    className={cn(
      'flex w-full max-w-md flex-col items-center gap-4 rounded-lg border border-slate-200 bg-white p-5 text-center shadow-sm dark:border-slate-700 dark:bg-slate-800',
      className,
    )}>
    <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400">
      <Alerts.AlertTriangle className="size-5" />
      <span className="font-medium">{title}</span>
    </div>
    {children}
  </div>
);
